import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Bed Management
    SETTING_LOAD_BED_CATEGORY,
    SETTING_CREATE_BED_CATEGORY,
    SETTING_UPDATE_BED_CATEGORY,
    SETTING_DELETE_BED_CATEGORY,

    SETTING_LOAD_BED,
    SETTING_CREATE_BED,
    SETTING_UPDATE_BED,
    SETTING_DELETE_BED,

    SETTING_CREATE_ROOM,
    SETTING_UPDATE_ROOM,
    SETTING_LOAD_ROOM,
    SETTING_LOAD_ALL_BED_MAPPING,
    SETTING_DELETE_ROOM,

    SETTING_UPDATE_ROOM_STATUS,
    // END Bed Management

} from "../../actions";

import {
    // Bed Management
    settingGetBedCategory,
    settingAddBedCategory,
    settingUpdateBedCategory,
    settingDeleteBedCategory,

    settingGetBed,
    settingAddBed,
    settingUpdateBed,
    settingDeleteBed,

    settingGetRoom,
    settingAddRoom,
    settingUpdateRoom,
    settingDeleteRoom,
    settingGetAllRoomBedMapping,

    settingUpdateChangeStatusRoom,

    // END Bed Management

} from "../../../helpers/setting-api";

import {
    getBedCategory,
    getBedCategorySuccess,
    getBed,
    getBedSuccess,
    getRoom,
    getRoomSuccess,
    getAllBedMapping,
    getAllBedMappingSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Bed Management
function* settingManagementLoadBedCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetBedCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_bed_category,
                    value: item.id_bed_category,
                }
            ));
            yield put(getBedCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddBedCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddBedCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getBedCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateBedCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateBedCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getBedCategory({ spa_id: payload.spa_id }, token));
            yield put(getBed({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteBedCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteBedCategory(items, token);
        if (dataRes.status === 'success') yield put(getBedCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadBed({ payload, token }) {
    try {
        const dataRes = yield settingGetBed(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_bed,
                    value: item.id_bed,
                }
            ));
            yield put(getBedSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddBed({ payload, token }) {
    try {
        const dataRes = yield settingAddBed(payload, token);
        if (dataRes.status === 'success') {
            yield put(getBed({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateBed({ payload, token }) {
    try {
        const dataRes = yield settingUpdateBed(payload, token);
        if (dataRes.status === 'success') {
            yield put(getBed({ spa_id: payload.spa_id }, token));
            // yield put(getBedCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteBed({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteBed(items, token);
        if (dataRes.status === 'success') yield put(getBed({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadRoom({ payload, token }) {
    try {
        const dataRes = yield settingGetRoom(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.number_room,
                    value: item.id_room,
                }
            ));
            yield put(getRoomSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddRoom({ payload, token }) {
    try {
        const dataRes = yield settingAddRoom(payload, token);
        if (dataRes.status === 'success') {
            yield put(getRoom({ spa_id: payload.spa_id }, token));
            yield put(getAllBedMapping({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateRoom({ payload, token }) {
    try {
        const dataRes = yield settingUpdateRoom(payload, token);
        if (dataRes.status === 'success') {
            yield put(getRoom({ spa_id: payload.spa_id }, token));
            yield put(getAllBedMapping({ spa_id: payload.spa_id }, token));
            // yield put(getBed({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}


function* settingManagementChangeStatusRoom({ payload, token }) {
    try {
        const dataRes = yield settingUpdateChangeStatusRoom(payload, token);
        if (dataRes.status === 'success') {
            yield put(getRoom({ spa_id: payload.spa_id }, token));

        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteRoom({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteRoom(items, token);
        if (dataRes.status === 'success') {
            yield put(getRoom({ spa_id: payload.spa_id }, token));
            yield put(getAllBedMapping({ spa_id: payload.spa_id }, token));
        }
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadAllRoomBedMapping({ payload, token }) {
    try {
        const dataRes = yield settingGetAllRoomBedMapping(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_bed,
                    value: item.id_room_bed_mapping,
                }
            ));
            yield put(getAllBedMappingSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Bed Management

// Bed Management
export function* watchLoadBedCategory() {
    yield takeEvery(
        SETTING_LOAD_BED_CATEGORY,
        settingManagementLoadBedCategory
    );
}
export function* watchAddBedCategory() {
    yield takeEvery(
        SETTING_CREATE_BED_CATEGORY,
        settingManagementAddBedCategory
    );
}
export function* watchUpdateBedCategory() {
    yield takeEvery(
        SETTING_UPDATE_BED_CATEGORY,
        settingManagementUpdateBedCategory
    );
}
export function* watchDeleteBedCategory() {
    yield takeEvery(
        SETTING_DELETE_BED_CATEGORY,
        settingManagementDeleteBedCategory
    );
}

export function* watchLoadBed() {
    yield takeEvery(
        SETTING_LOAD_BED,
        settingManagementLoadBed
    );
}
export function* watchAddBed() {
    yield takeEvery(
        SETTING_CREATE_BED,
        settingManagementAddBed
    );
}
export function* watchUpdateBed() {
    yield takeEvery(
        SETTING_UPDATE_BED,
        settingManagementUpdateBed
    );
}

export function* watchDeleteBed() {
    yield takeEvery(
        SETTING_DELETE_BED,
        settingManagementDeleteBed
    );
}
export function* watchLoadRoom() {
    yield takeEvery(
        SETTING_LOAD_ROOM,
        settingManagementLoadRoom
    );
}
export function* watchAddRoom() {
    yield takeEvery(
        SETTING_CREATE_ROOM,
        settingManagementAddRoom
    );
}
export function* watchUpdateRoom() {
    yield takeEvery(
        SETTING_UPDATE_ROOM,
        settingManagementUpdateRoom
    );
}
export function* watchDeleteRoom() {
    yield takeEvery(
        SETTING_DELETE_ROOM,
        settingManagementDeleteRoom
    );
}
export function* watchChangeStatusRoom() {
    yield takeEvery(
        SETTING_UPDATE_ROOM_STATUS,
        settingManagementChangeStatusRoom
    );
}
export function* watchLoadAllRoomBedMapping() {
    yield takeEvery(
        SETTING_LOAD_ALL_BED_MAPPING,
        settingManagementLoadAllRoomBedMapping
    );
}

// END Bed Management

export default function* rootSaga() {
    yield all([
        //  Bed Management 
        fork(watchLoadBedCategory),
        fork(watchAddBedCategory),
        fork(watchUpdateBedCategory),
        fork(watchDeleteBedCategory),

        fork(watchLoadBed),
        fork(watchAddBed),
        fork(watchUpdateBed),

        fork(watchDeleteBed),

        fork(watchLoadRoom),
        fork(watchAddRoom),
        fork(watchUpdateRoom),
        fork(watchDeleteRoom),

        fork(watchChangeStatusRoom),

        fork(watchLoadAllRoomBedMapping),

    ])
}